import { render, staticRenderFns } from "./product-detail-agreement.vue?vue&type=template&id=5e9696dd&"
import script from "./product-detail-agreement.vue?vue&type=script&lang=js&"
export * from "./product-detail-agreement.vue?vue&type=script&lang=js&"
import style0 from "./product-detail-agreement.vue?vue&type=style&index=0&id=5e9696dd&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports